export default __webpack_public_path__ + "static/media/tooth.b144406f.svg";